import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { useEffect } from "react";

import Navbar from "./components/Navbar";
import CursorGlow from "./components/CursorGlow";

import Home from "./pages/Home";
import About from "./pages/About";
import Skills from "./pages/Skills";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";

function AnimatedRoutes() {
  const location = useLocation();

  useEffect(() => {
    const titles = {
      "/": "Siddharth – Full Stack Developer",
      "/about": "About – Siddharth",
      "/skills": "Skills – Siddharth",
      "/projects": "Projects – Siddharth",
      "/contact": "Contact – Siddharth",
    };

    document.title = titles[location.pathname] || "Siddharth";
  }, [location.pathname]);

  return (
    <AnimatePresence
      mode="wait"
      onExitComplete={() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "instant",
        });
      }}
    >
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <BrowserRouter>
      <CursorGlow />
      <Navbar />
      <AnimatedRoutes />
    </BrowserRouter>
  );
}

export default App;